<template>
  <!-- Main navbar -->
  <div v-if="user?.tarif"
    class="navbar navbar-dark navbar-expand-lg navbar-static border-bottom border-bottom-white border-opacity-10 py-0">
    <div class="container-fluid">
      <div class="d-flex d-lg-none me-2">
        <button type="button" class="navbar-toggler sidebar-mobile-main-toggle rounded" @click="showMainSidebar = true">
          <i class="ph-list"></i>
        </button>
      </div>

      <div class="navbar-brand">
        <router-link to="/chat" class="d-inline-flex align-items-center">
          <img src="" alt="">
          <img src="" class="d-none d-sm-inline-block h-16px ms-3" alt="">
          <img alt="logo" loading="lazy" width="136" height="100" decoding="async" data-nimg="1"
            class="w-[136px] h-auto d-none d-sm-inline-block ms-3" src="./assets/images/makergptlogo.svg"
            style="color: transparent;">
        </router-link>
      </div>

      <div class="d-lg-none ms-2">
        <button class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-mobile"
          aria-expanded="false">
          <i class="ph-squares-four"></i>
        </button>
      </div>

      <div class="navbar-collapse order-2 order-lg-1 collapse" id="navbar-mobile" style="">
        <ul class="navbar-nav mt-2 mt-lg-0">
          <li class="nav-item">
            <a :href="`https://t.me/GptMAKER_ai_bot/?start=k_${user.commonKey}`" class="navbar-nav-link rounded"
              target="_blank">
              Продолжить в Telegram <i class="ph-paper-plane-tilt mx-2" style="color: #3d9cff"></i></a>
          </li>
          <li class="nav-item">
            <a :href="`https://t.me/GptMAKER_ai_support_bot/?start=lnfrommakergptchat-txstartmessage`" class="navbar-nav-link rounded"
              target="_blank">
              Обратная связь <i class="ph-smiley mx-1"></i></a>
          </li>
        </ul>
      </div>

      <ul class="nav gap-sm-2 order-1 order-lg-2 ms-auto">
        <li class="nav-item" v-if="user?.tarif">
          <span class="navbar-nav-link rounded cursor-pointer" data-bs-toggle="modal" data-bs-target="#go_to_payment">
            <span class="badge bg-info bg-opacity-20 text-info me-2">{{ user?.tarif }}</span>
            Баланс: {{ balance?.toFixed('2') || 0 }}₽
          </span>
        </li>
        <!--
        <li class="nav-item">
          <a href="#" class="navbar-nav-link rounded" @click.prevent="switchLang">{{ lang }}</a>
        </li>
        -->
        <li class="nav-item nav-item-dropdown-lg dropdown">
          <a href="#" class="navbar-nav-link align-items-center rounded p-1" data-bs-toggle="dropdown"
            aria-expanded="false">
            <div class="">
              <img src="./assets/images/user_m_4.png" class="w-32px h-32px rounded" alt="">
              <span class="status-indicator bg-success"></span>
            </div>
            <span class="d-none d-lg-inline-block mx-lg-2">{{ user.first_name || '' }} {{ user.last_name || '' }}</span>
          </a>
          <div class="dropdown-menu dropdown-menu-end wmin-lg-400">
            <div class="card shadow-none border-bottom border-bottom-warning rounded-0">
              <div class="card-header">
                <h6 class="mb-0">Пользователь</h6>
              </div>

              <div class="card-body" v-if="user?.tarif">
                <div class="d-sm-flex flex-sm-wrap mb-3">
                  <div class="fw-semibold">Имя:</div>
                  <div class="ms-sm-auto mt-1 mt-sm-0">{{ user.first_name || '' }} {{ user.last_name || '' }} / {{
                    user.username || '' }}</div>
                </div>
                <div class="d-sm-flex flex-sm-wrap mb-3">
                  <div class="fw-semibold">Создан:</div>
                  <div class="ms-sm-auto mt-1 mt-sm-0">{{ moment(user.creationDate).format('YYYY-MM-DD HH.mm') }}</div>
                </div>
                <div class="d-sm-flex flex-sm-wrap mb-3">
                  <div class="fw-semibold">Баланс:</div>
                  <div class="ms-sm-auto mt-1 mt-sm-0">{{ user.balance?.toFixed('2') || 0 }}</div>
                </div>
                <div class="d-sm-flex flex-sm-wrap mb-3" v-if="user.balance?.parent">
                  <div class="fw-semibold">Родитель:</div>
                  <div class="ms-sm-auto mt-1 mt-sm-0">{{ user.balance?.parent }}</div>
                </div>
                <div class="d-sm-flex flex-sm-wrap mb-3">
                  <div class="fw-semibold">Тариф:</div>
                  <div class="ms-sm-auto mt-1 mt-sm-0">{{ user.tarif || 'не задан' }}</div>
                </div>
                <!--
                <div class="d-sm-flex flex-sm-wrap mb-3">
                  <div class="fw-semibold">commonKey:</div>
                  <div class="ms-sm-auto mt-1 mt-sm-0">{{ user.commonKey || '' }}</div>
                </div>
                <div class="d-sm-flex flex-sm-wrap mb-3">
                  <div class="fw-semibold">Ключ доступа:</div>
                  <div class="ms-sm-auto mt-1 mt-sm-0">{{ user.accessKey || '' }}</div>
                </div>
                    <div class="mb-3">
                        <label class="form-label">Ключ API</label>
                        <input v-model="apiKey" type="text" class="form-control" placeholder="">
                    </div>
                    <div class="mb-3">
                        <label class="form-label">user.accessKey</label>
                        <input v-model="userAccessKey" type="text" class="form-control" placeholder="">
                    </div>
                    <div class="text-end">
                        <button @click.prevent="getUser" type="submit" class="btn btn-primary">Загрузить юзера</button>
                    </div>
                    -->
              </div>
            </div>
            <router-link class="dropdown-item" to="/settings"><i class="ph-gear me-2"></i> Настройки</router-link>
            <span class="dropdown-item cursor-pointer" data-bs-toggle="modal" data-bs-target="#go_to_payment"><i
                class="ph-currency-rub me-2"></i> Пополнить баланс</span>
            <a @click.stop="logout" href="#" class="dropdown-item"><i class="ph-sign-out me-2"></i> Выход</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <!-- /main navbar -->

  <!-- Page content -->
  <div class="page-content">

    <!-- Main sidebar -->
    <div v-if="user?.tarif" class="sidebar sidebar-main sidebar-expand-lg border-0"
      :class="showMainSidebar ? 'sidebar-mobile-expanded' : ''">

      <!-- Sidebar content -->
      <div class="sidebar-content">

        <!-- Sidebar header -->
        <div class="sidebar-section">
          <div class="sidebar-section-body d-flex justify-content-center">
            <!--<h5 class="sidebar-resize-hide flex-grow-1 my-auto">Навигация</h5>-->
            <div>
              <button type="button"
                class="btn btn-flat-white btn-icon btn-sm rounded-pill border-transparent sidebar-control sidebar-main-resize d-none d-lg-inline-flex">
                <i class="ph-arrows-left-right"></i>
              </button>

              <button type="button"
                class="btn btn-icon btn-sm rounded-pill border-transparent sidebar-mobile-main-toggle d-lg-none"
                @click="showMainSidebar = false">
                <i class="ph-x"></i>
              </button>
            </div>
          </div>
        </div>
        <!-- /sidebar header -->

        <!-- Main navigation -->
        <div class="sidebar-section">
          <ul class="nav nav-sidebar" data-nav-type="accordion">
            <!-- Main -->
            <li class="nav-item-header pt-0">
              <!--<div class="text-uppercase fs-sm lh-sm opacity-50 sidebar-resize-hide">Main</div>-->
              <i class="ph-dots-three sidebar-resize-show"></i>
            </li>
            <li class="nav-item">
              <router-link class="nav-link rounded" to="/settings">Настройки</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link rounded" to="/stats">Статистика</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link rounded" to="/userdb">Базы данных</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link rounded" to="/chat">Чат</router-link>
            </li>
            <li class="nav-item-header">
              <div class="text-uppercase fs-sm lh-sm opacity-50 sidebar-resize-hide">Мои диалоги</div>
              <i class="ph-dots-three sidebar-resize-show"></i>
            </li>
            <li class="nav-item">
              <router-link class="nav-link rounded" to="/usermessages">История</router-link>
            </li>
            <li class="nav-item-header" v-if="user.accessRights.length > 0">
              <div class="text-uppercase fs-sm lh-sm opacity-50 sidebar-resize-hide">Администрирование</div>
              <i class="ph-dots-three sidebar-resize-show"></i>
            </li>
            <li class="nav-item" v-if="(user.accessRights || []).indexOf('dashboard') >= 0">
              <router-link class="nav-link rounded" to="/dashboard">Дашборд</router-link>
            </li>
            <li class="nav-item" v-if="(user.accessRights || []).indexOf('sysstat') >= 0">
              <router-link class="nav-link rounded" to="/sysstats">Статистика и биллинг</router-link>
            </li>
            <li class="nav-item" v-if="(user.accessRights || []).indexOf('sysstat') >= 0">
              <router-link class="nav-link rounded" to="/admin-settings">Настройки</router-link>
            </li>
            <li class="nav-item" v-if="(user.accessRights || []).indexOf('users') >= 0">
              <router-link class="nav-link rounded" to="/users">Пользователи</router-link>
            </li>
            <li class="nav-item" v-if="(user.accessRights || []).indexOf('users') >= 0">
              <router-link class="nav-link rounded" to="/clients">Клиенты</router-link>
            </li>
            <li class="nav-item" v-if="(user.accessRights || []).indexOf('messages') >= 0">
              <router-link class="nav-link rounded" to="/messages">Все сообщения</router-link>
            </li>
            <li class="nav-item" v-if="(user.accessRights || []).indexOf('rag') >= 0">
              <router-link class="nav-link rounded" to="/rag">Администрирование RAG</router-link>
            </li>
            <li class="nav-item" v-if="(user.accessRights || []).indexOf('todo') >= 0">
              <router-link class="nav-link rounded" to="/todo">ToDo</router-link>
            </li>
          </ul>
        </div>
        <!-- /main navigation -->

      </div>
      <!-- /sidebar content -->
    </div>
    <!-- /main sidebar -->

    <!-- Main content -->
    <div class="content-wrapper">
      <router-view />
      <!-- /inner content -->
      <!-- Footer -->
      <div class="navbar navbar-sm navbar-footer py-0  border-0">
        <div class="container-fluid">
          <span :class="lastMessage.type == 'error' ? 'badge bg-danger bg-opacity-20 text-danger' : ''">
          <div class="spinner-border text-warning me-1" role="status" v-if="lastMessage.type == 'loading'">
            <span class="visually-hidden"></span>
          </div> {{ lastMessage.message ? lastMessage.message : '' }}</span>

          <ul class="nav">
            <li class="nav-item">
              <a href="https://api.maker-gpt.pro/docs" class="navbar-nav-link navbar-nav-link-icon rounded"
                target="_blank">
                <div class="d-flex align-items-center mx-md-1">
                  <i class="ph-file-text"></i>
                  <span class="d-none d-md-inline-block ms-2">Документация по API</span>
                </div>
              </a>
            </li>
            <li class="nav-item">
              <a href="https://maker-studio.pro" class="navbar-nav-link navbar-nav-link-icon rounded" target="_blank">
                <div class="d-flex align-items-center mx-md-1">
                  <i class="ph-house"></i>
                  <span class="d-none d-md-inline-block ms-2">MAKER</span>
                </div>
              </a>
            </li>
            <li class="nav-item">
              <a href="https://t.me/GptMAKER_ai_bot" class="navbar-nav-link navbar-nav-link-icon rounded"
                target="_blank">
                <div class="d-flex align-items-center mx-md-1">
                  <i class="ph-paper-plane-tilt"></i>
                  <span class="d-none d-md-inline-block ms-2">Telegram Bot</span>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!-- /footer -->

    </div>
    <!-- /main content -->

  </div>
  <!-- /page content -->
  <div v-if="user?.tarif" class="offcanvas offcanvas-end" tabindex="-1" id="demo_config">
    <div class="position-absolute top-50 end-100 visible">
      <button type="button" class="btn btn-primary btn-icon translate-middle-y rounded-end-0" data-bs-toggle="offcanvas"
        data-bs-target="#demo_config">
        <i class="ph-gear"></i>
      </button>
    </div>

    <div class="offcanvas-header border-bottom py-0">
      <h5 class="offcanvas-title py-3">Настройки</h5>
      <button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill"
        data-bs-dismiss="offcanvas">
        <i class="ph-x"></i>
      </button>
    </div>

    <div class="offcanvas-body">

      <div class="fw-semibold mb-2">Контекст</div>
      <div class="list-group mb-3">
        <label class="list-group-item list-group-item-action form-check border-width-0 rounded mb-0">
          <div class="d-flex flex-fill my-1">
            <div class="form-check-label d-flex me-2">
              <div>
                <span class="fw-bold">Сохранять контекст</span>
                <div class="text-muted"></div>
              </div>
            </div>
            <input @change="changeSwitchContext" v-model="user.contextEnabled" type="checkbox" name="layout-direction"
              value="rtl" class="form-check-input cursor-pointer m-0 ms-auto">
          </div>
        </label>
      </div>
      <div class="fw-semibold mb-2">Шаблоны промптов</div>
      <div class="card-group-vertical">
        <div
          v-for="(p,index) in prompts"
          :key="index"
          class="card border shadow-none">
          <div class="card-header p-2">
            <h6 class="mb-0">
              <a data-bs-toggle="collapse" class="d-flex align-items-center text-body collapsed"
                :href="`#prompt_${index}`" aria-expanded="false">
                {{ p.name }}
                <i class="ph-caret-down collapsible-indicator ms-auto"></i>
              </a>
            </h6>
          </div>

          <div :id="`prompt_${index}`" class="collapse" style="">
            <div class="card-body">
              <div class="mb-2">
                {{ p.content }}
              </div>
              <!--
              <a href="#demo_config" class="fw-semibold" data-bs-toggle="collapse"
                @click="promptToChat(p.content)"> Копировать в чат</a>
              -->
              <a href="#" class="fw-semibold"
                @click.stop="promptToChat(p.content)"> Копировать в чат</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--
    <div class="border-top text-center py-2 px-3">
      <a href="№"
        class="btn btn-primary fw-semibold w-100 my-1">
        Сохранить
      </a>
    </div>
    -->
  </div>

  <div id="go_to_payment" class="modal fade" tabindex="-1" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">

        <form action="#">
          <div class="modal-body pb-1">
            <div class="mb-1">
              <div class="row">
                <div class="col-sm-12">
                  <label class="form-label">Сумма пополнения</label>
                  <input type="number" placeholder="1000" class="form-control" v-model="chargeAmount">
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer border-0 p-2">
            <button type="button" class="btn btn-link" data-bs-dismiss="modal" ref="modalRef">Отмена</button>
            <button type="button" class="btn btn-primary" @click.stop="goToPayment">Перейти к оплате</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
// import StatLine from '@/components/StatLine.vue'
import api from '@/api/maker-gpt'
import moment from 'moment'

import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { setInterval } from 'core-js'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

export default {
  components: {
  },
  setup () {
    const store = useStore()
    const router = useRouter()
    const count = ref(0)
    const userName = ref('Администратор')
    const lang = ref('RU')
    const user = computed(() => store.getters.getActiveUser.user || {})
    const userMessage = computed(() => store.getters.getUserMessage)
    const chargeAmount = ref(1000)
    const modalRef = ref(null)
    const showMainSidebar = ref(null)
    const balance = computed(() => store.getters.getBalance)
    const prompts = computed(() => store.state.prompts)
    // expose to template and other options API hooks

    const loadData = async function () {
      if (localStorage.getItem('accessKey')) store.dispatch('mainLoad')
    }

    const switchLang = function () {
      lang.value = lang.value === 'RU' ? 'EN' : 'RU'
    }

    const logout = function () {
      store.commit('logout')
      router.push('/')
    }

    const changeSwitchContext = function () {
      store.dispatch('switchContext', user.value.contextEnabled)
    }

    const goToPayment = async function () {
      const { url } = await api.queryMakerGptAPI('/v1/system/getpaymenturl', {
        user: { accessKey: localStorage.getItem('accessKey') },
        amount: chargeAmount.value,
        shp_system_name: 'MAKER-GPT',
        description: 'Пополнение баланса MAKER-GPT'
      })
      if (url) window.open(url, '_blank')
      modalRef.value?.dispatchEvent(new Event('click'))
    }

    const showToast = function (msg) {
      toast(msg.text || msg, {
        autoClose: msg.autoClose || 1000,
        type: msg.type || 'default',
        position: 'top-center'
      })
      store.commit('clearUserMessage')
    }

    const promptToChat = function (prompt) {
      store.commit('setPrompt', prompt)
      store.dispatch('showMessage', { text: 'Промпт скопирован в чат' })
    }

    watch(userMessage, (newValue, oldValue) => {
      if (newValue && newValue !== oldValue) showToast(newValue)
    })

    watch(balance, (newValue, oldValue) => {
      if (newValue > oldValue && oldValue > 0) store.dispatch('showMessage', { text: 'Баланс пополнен!' })
    })

    return {
      count,
      userName,
      loadData,
      user,
      moment,
      lastMessage: computed(() => store.state.systemMessages[store.state.systemMessages.length - 1] || { type: 'info', message: '' }),
      lang,
      switchLang,
      logout,
      changeSwitchContext,
      chargeAmount,
      goToPayment,
      modalRef,
      showMainSidebar,
      balance,
      prompts,
      promptToChat
    }
  },
  mounted () {
    console.log('Приложение запущено')
  },
  created () {
    // const store = useStore()
    this.loadData()
    // eslint-disable-next-line no-unused-vars
    const updateData = setInterval(() => {
      // store.dispatch('reloadUser')
    }, 10000)
  }
}
</script>

<style>
</style>
